<div  style="overflow:hidden;">
<div class="row" style="height: 100vh;">
  <div class="col-md-6 mobImg"
    style="background-image: url(assets/img/loginImage.webp); background-repeat: no-repeat; background-size: cover;">

  </div>


  <div class="container col-md-5 xMargin">

    <div class="  mx-auto">
      <div class="my-5">
        <div class="card-body">
          <h3 class="card-title text-center">Reset Wachtwoord</h3>
          <form [formGroup]="resetPasswordForm" (ngSubmit)="resetPassword()">
            <p class="">Vul uw e-mailadres in om uw wachtwoord te resetten. U krijgt verdere instructies per mail.
              (Controleer ook de spam-folder)</p>
            <div *ngIf="resetPasswordForm.controls.email.errors" class="text-danger">
              Vul een geldig e-mailadres in.
            </div>
            <div class="form-group">
              <input type="email" required formControlName="email" autocomplete="email" class="form-control"
                placeholder="E-mail" #passwordResetEmail required>
            </div>

            <!-- Calling ForgotPassword from AuthService Api -->
            <div class="form-group">
              <input type="submit" class="btn btn-lg btn-primary btn-block" value="Reset wachtwoord">
            </div>

            <div class="redirectToLogin">
              <a class="redirect" routerLink="/login">Ga terug </a>
            </div>

          </form>



        </div>
      </div>
    </div>
  </div>
</div>